import { Button, Icon, ICONS_ENUM, Typography } from '@sanlam-glacier/app-common/components';
import styles from './secondary-dropdown.module.scss';
import clsx from 'clsx';
import { formatZAR } from 'modules/clients/utils/format-cuurency';

type SecondaryDropdownProps = {
  title: string;
  amountDescription: string;
  amount: number;
  buttonTitle?: string;
  isPrimaryDropdown?: boolean;
  shouldHaveBorder?: boolean;
  id: number;
  isOpen: boolean;
  onToggle: (id: number) => void;
  children: (props: { isOpen: boolean }) => React.ReactNode;
};

const SecondaryDropdown = ({
  title,
  amountDescription,
  amount,
  buttonTitle,
  isPrimaryDropdown,
  shouldHaveBorder,
  children,
  id,
  isOpen,
  onToggle
}: SecondaryDropdownProps) => {
  const titleText = () => {
    return (
      <Typography
        variant={isPrimaryDropdown ? Typography.VARIANT.B3 : Typography.VARIANT.B4}
        weight={Typography.WEIGHT.MEDIUM}
      >
        {title}
      </Typography>
    );
  };

  const amountText = () => {
    return (
      <Typography
        className={styles.text}
        variant={Typography.VARIANT.B4}
        weight={Typography.WEIGHT.MEDIUM}
      >
        <div className={styles.amountContainer}>
          <div>{amountDescription}:</div>
          <div className={styles.amountDigits}>{formatZAR(amount)}</div>
        </div>
      </Typography>
    );
  };

  const collapseButton = () => {
    return (
      <Button
        className={buttonTitle ? '' : styles.collapseButton}
        variant={Button.VARIANT.TERTIARY}
        size={Button.SIZE.SMALL}
        onClick={() => {
          onToggle(id);
        }}
        endIcon={
          <Icon
            className={styles.collapseIcon}
            icon={
              isOpen
                ? ICONS_ENUM.HARDWARE_KEYBOARD_ARROW_UP
                : ICONS_ENUM.HARDWARE_KEYBOARD_ARROW_DOWN
            }
          />
        }
      >
        {buttonTitle && (isOpen ? `Collapse ${buttonTitle}` : `Expand ${buttonTitle}`)}
      </Button>
    );
  };

  return (
    <div>
      <div className={isPrimaryDropdown ? styles.primaryContainer : styles.secondaryContainer}>
        <div className={styles.headingContainer}>
          {titleText()}
          <div className={styles.collapseContainer}>
            {!isOpen && amountText()}
            {collapseButton()}
          </div>
        </div>
      </div>
      <div
        className={clsx([
          styles.content,
          shouldHaveBorder && (isPrimaryDropdown ? styles.primaryBorder : styles.secondaryBorder)
        ])}
      >
        {children({ isOpen })}
      </div>
    </div>
  );
};

export default SecondaryDropdown;
